export const GPT_HEAD_DRUG_PAGE = `
// list of all breakpoints we are using in the ads
// size property corresponds to sizeMapping used in the ad slots
// mq property lists the mediaquery this size should be visible to
const adBreakpoints = {
  start: { size: 0, mq: '(max-width: 330px)' },
  xxs: { size: 330, mq: '(min-width: 330px) and (max-width: 350px)' },
  xs: { size: 350, mq: '(min-width: 350px) and (max-width: 366px)' },
  sm: { size: 366, mq: '(min-width: 366px) and (max-width: 432px)' },
  md: { size: 432, mq: '(min-width: 432px) and (max-width: 672px)' },
  lg: { size: 672, mq: '(min-width: 672px) and (max-width: 758px)' },
  xl: { size: 758, mq: '(min-width: 760px) and (max-width: 1002px)' },
  xxl: { size: 1002, mq: '(min-width: 1002px) and (max-width: 1025px)' },
  xxxl: { size: 1025, mq: '(min-width: 1025px) and (max-width: 1380px)' },
  xxxxl: {
    size: 1380,
    mq: '(min-width: 1380px) and (max-width: 1670px)',
  },
  end: { size: 1670, mq: '(min-width: 1670px)' },
}

// size mapping array to be filled later, but this way we can access it globally
var sizeMapping = {
leftRight: null,
top: null,
inContent: null,
anchor: null
};

googletag.cmd.push(function () {
  // size mapping specifically for vertical ads used left & right
  sizeMapping.leftRight = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.end.size, 0],
      [
        [300, 600],
        [300, 250],
        [160, 600],
      ]
    )
    .addSize([adBreakpoints.xxxxl.size, 0], [[160, 600]])
    .addSize([adBreakpoints.xxs.size, 0], [])
    .build()

  // size mapping specifically for horizontal ads at the top and bottom
  // to make sure the top ads only impact a minimal vertical space
  sizeMapping.top = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxxxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xxl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [970, 90],
        [970, 250],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [300, 50],
        [300, 100],
        [320, 180],
        [320, 100],
        [320, 50],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping for all in content and footer ads
  sizeMapping.inContent = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [970, 90],
        [970, 250],
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.xl.size, 0],
      [
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.lg.size, 0],
      [
        [640, 480],
        [640, 360],
        [400, 300],
        [336, 280],
        [336, 336],
        [300, 50],
        [320, 180],
        [300, 100],
        [320, 100],
        [300, 250],
        [320, 50],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.md.size, 0],
      [
        [400, 300],
        [336, 280],
        [336, 336],
        [300, 50],
        [320, 180],
        [300, 100],
        [320, 100],
        [300, 250],
        [320, 50],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.sm.size, 0],
      [
        [336, 280],
        [336, 336],
        [300, 50],
        [320, 180],
        [300, 100],
        [320, 100],
        [300, 250],
        [320, 50],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [300, 50],
        [320, 180],
        [300, 100],
        [320, 100],
        [300, 250],
        [320, 50],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping for all anchor ads
  sizeMapping.anchor = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 50],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
.build()

  // defining all the ad slots
  googletag
    .defineSlot(
      '/22809915073/SingleCare_Drug-Page/Drug-page_top',
      getAllAdSizes(sizeMapping.top),
      'div-gpt-ad-1685465601155-0'
    )
    .defineSizeMapping(sizeMapping.top)
    .addService(googletag.pubads())
  // googletag
  //   .defineSlot(
  //     '/22809915073/SingleCare_Drug-Page/drug-page_in-content-1st',
  //     getAllAdSizes(inContentMapping),
  //     'div-gpt-ad-1685465718933-0'
  //   )
  //   .defineSizeMapping(inContentMapping)
  //   .addService(googletag.pubads())
  googletag
    .defineSlot(
      '/22809915073/SingleCare_Drug-Page/Drug-page_in-content-2nd',
      getAllAdSizes(sizeMapping.inContent),
      'div-gpt-ad-1685465793237-0'
    )
    .defineSizeMapping(sizeMapping.inContent)
    .addService(googletag.pubads())
  googletag
    .defineSlot(
      '/22809915073/SingleCare_Drug-Page/Drug-page_left-hand_1st',
      getAllAdSizes(sizeMapping.leftRight),
      'div-gpt-ad-1685465849075-0'
    )
    .defineSizeMapping(sizeMapping.leftRight)
    .addService(googletag.pubads())
  googletag
    .defineSlot(
      '/22809915073/SingleCare_Drug-Page/Drug-page_right-hand_1st',
      getAllAdSizes(sizeMapping.leftRight),
      'div-gpt-ad-1685465967121-0'
    )
    .defineSizeMapping(sizeMapping.leftRight)
    .addService(googletag.pubads())
  const bottomAnchorSlot = googletag
    .defineSlot(
      '/22809915073/SingleCare_Drug-Page/Drug-page_bottom-anchor',
      getAllAdSizes(sizeMapping.anchor),
      'div-gpt-ad-1685723492183-0'
    )
    .defineSizeMapping(sizeMapping.anchor)
    .addService(googletag.pubads())
    let stickyAnchorInitialized = false;
    googletag.pubads().addEventListener('slotOnload', event => {
      // we need to know when if the anchor ad is being served and loaded
      // if not, no need to create a sticky ad
      if (event.slot == bottomAnchorSlot) {
        // the anchor ad is currently loaded

        if (stickyAnchorInitialized === false) {
          // as the ads can be refreshed, this event will be fired on each refresh
          // so we need to make sure we only initialize the code for the sticky ad once
          const stickyContainer = document.querySelector('#bottomStickyAd');
          const topTriggerElement = document.querySelector('#drug-pricing');
          const bottomTriggerElement = document.querySelector('.homepage-footer');

          // we'll use intersection observer to track if the sticky ad can be shown
          const triggerObserver = new IntersectionObserver(
            entries => {
              let hideAd = false;
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  hideAd = true;
                }
              });

              if (hideAd == true) {
                // one of the trigger elements is visible, hide the ad
                stickyContainer.classList.remove('bottomAdsBanner');
              } else {
                // the trigger element is not visible, show the ad
                stickyContainer.classList.add('bottomAdsBanner');
              }
            },
            {
              threshold: 0
            }
          );
          triggerObserver.observe(topTriggerElement);
          triggerObserver.observe(bottomTriggerElement);
          stickyAnchorInitialized = true;
        }
      }
    });
  // targeting variables
  // left this unchanged
  var seo_nameMeta = document.querySelector("meta[property='seo_name']")
  if (seo_nameMeta) {
    googletag
      .pubads()
      .setTargeting('seo_name', seo_nameMeta.content.slice(0, 40))
  }

  var placement_nameMeta = document.querySelector(
    "meta[property='placement_name']"
  )
  if (placement_nameMeta) {
    googletag
      .pubads()
      .setTargeting(
        'placement_name',
        placement_nameMeta.content.slice(0, 40)
      )
  }

  var environmentMeta = document.querySelector(
    "meta[property='environment']"
  )
  if (environmentMeta) {
    googletag
      .pubads()
      .setTargeting('environment', environmentMeta.content.slice(0, 40))
  }

  var logged_inMeta = document.querySelector("meta[property='logged_in']")
  if (logged_inMeta) {
    googletag
      .pubads()
      .setTargeting('logged_in', logged_inMeta.content.slice(0, 40))
  }

  googletag.pubads().enableSingleRequest()
  googletag.pubads().collapseEmptyDivs()
  googletag.pubads().setCentering(true);
  adSlotsBorder();
  googletag.enableServices()
})`;

export const EXCLUDED_SEO_FOR_TIMEOUT = [
  'xdemvy',
  'synthroid',
  'restasis',
  'xiidra',
  'repatha',
  'otezla',
  'levoxyl',
  'repatha-sureclick',
  'restasis-multidose',
  'tirosint',
  'cequa',
  'unithroid',
  'tyrvaya',
  'repatha-pushtronex-system',
  'miebo',
  'vevye',
  'xdemvy',
  'eliquis',
  'adderall-xr',
  'ozempic-0-25-or-0-5-mg-dose',
  'ozempic',
  'jardiance',
  'wegovy',
  'xarelto',
  'vyvanse',
  'symbicort',
  'trulicity',
  'synthroid',
  'saxenda',
  'farxiga',
  'trelegy-ellipta',
  'entresto',
  'ozempic-1-mg-dose',
  'breo-ellipta',
  'januvia',
  'linzess',
  'advair-diskus',
  'restasis',
  'rybelsus',
  'flovent-hfa',
  'lantus-solostar',
  'victoza',
  'ambien',
  'qsymia',
  'lantus',
  'advair-hfa',
  'anoro-ellipta',
  'creon',
  'xiidra',
  'trintellix',
  'vascepa',
  'novolog-flexpen',
  'ozempic-2-mg-dose',
  'gemtesa',
  'xifaxan',
  'brilinta',
  'lumigan',
  'wellbutrin-xl',
  'tresiba-flextouch',
  'jublia',
  'janumet',
  'breztri-aerosphere',
  'novolog',
  'spiriva-respimat',
  'spiriva-handihaler',
  'dupixent',
  'lo-loestrin-fe',
  'praluent',
  'latuda',
  'lovenox',
  'clenpiq',
  'dexcom-g6-sensor',
  'nurtec',
  'qvar-redihaler',
  'repatha',
  'abilify-maintena',
  'prolensa',
  'otezla',
  'vraylar',
  'epipen-2-pak',
  'multaq',
  'emgality',
  'dexcom-g6-transmitter',
  'stiolto-respimat',
  'novolin-n',
  'levemir',
  'mirena-52-mg',
  'prempro',
  'ajovy',
  'toujeo-solostar',
  'trulance',
  'janumet-xr',
  'eliquis-dvt-pe-starter-pack',
  'enbrel',
  'belbuca',
  'vyzulta',
  'humira',
  'tresiba',
  'belsomra',
  'rexulti',
  'zenpep',
  'ubrelvy',
  'metanx',
  'levoxyl',
  'xigduo-xr',
  'onetouch-verio',
  'durezol',
  'novolin-70-30',
  'xtampza-er',
  'pulmicort-flexhaler',
  'arnuity-ellipta',
  'ambien-cr',
  'repatha-sureclick',
  'estrogel',
  'dexcom-g6-receiver',
  'nucynta',
  'tobradex'
];

export const GPT_TIMEOUT_HEAD_DRUG_PAGE = `
// list of all breakpoints we are using in the ads
// size property corresponds to sizeMapping used in the ad slots
// mq property lists the mediaquery this size should be visible to
const adBreakpoints = {
  start: { size: 0, mq: '(max-width: 330px)' },
  xxs: { size: 330, mq: '(min-width: 330px) and (max-width: 350px)' },
  xs: { size: 350, mq: '(min-width: 350px) and (max-width: 366px)' },
  sm: { size: 366, mq: '(min-width: 366px) and (max-width: 432px)' },
  md: { size: 432, mq: '(min-width: 432px) and (max-width: 672px)' },
  lg: { size: 672, mq: '(min-width: 672px) and (max-width: 758px)' },
  xl: { size: 758, mq: '(min-width: 760px) and (max-width: 1002px)' },
  xxl: { size: 1002, mq: '(min-width: 1002px) and (max-width: 1025px)' },
  xxxl: { size: 1025, mq: '(min-width: 1025px) and (max-width: 1380px)' },
  xxxxl: {
    size: 1380,
    mq: '(min-width: 1380px) and (max-width: 1670px)',
  },
  end: { size: 1670, mq: '(min-width: 1670px)' },
}

// size mapping array to be filled later, but this way we can access it globally
var sizeMapping = {
leftRight: null,
top: null,
inContent: null,
anchor: null
};

googletag.cmd.push(function () {
  // size mapping specifically for vertical ads used left & right
  sizeMapping.leftRight = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.end.size, 0],
      [
        [300, 600],
        [300, 250],
        [160, 600],
      ]
    )
    .addSize([adBreakpoints.xxxxl.size, 0], [[160, 600]])
    .addSize([adBreakpoints.xxs.size, 0], [])
    .build()

  // size mapping specifically for horizontal ads at the top and bottom
  // to make sure the top ads only impact a minimal vertical space
  sizeMapping.top = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxxxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xxl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [970, 90],
        [970, 250],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [300, 50],
        [300, 100],
        [320, 180],
        [320, 100],
        [320, 50],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping for all in content and footer ads
  sizeMapping.inContent = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [970, 90],
        [970, 250],
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.xl.size, 0],
      [
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.lg.size, 0],
      [
        [640, 480],
        [640, 360],
        [400, 300],
        [336, 280],
        [336, 336],
        [300, 50],
        [320, 180],
        [300, 100],
        [320, 100],
        [300, 250],
        [320, 50],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.md.size, 0],
      [
        [400, 300],
        [336, 280],
        [336, 336],
        [300, 50],
        [320, 180],
        [300, 100],
        [320, 100],
        [300, 250],
        [320, 50],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.sm.size, 0],
      [
        [336, 280],
        [336, 336],
        [300, 50],
        [320, 180],
        [300, 100],
        [320, 100],
        [300, 250],
        [320, 50],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [300, 50],
        [320, 180],
        [300, 100],
        [320, 100],
        [300, 250],
        [320, 50],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping for all anchor ads
  sizeMapping.anchor = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 50],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
.build()

  // defining all the ad slots
  googletag
    .defineSlot(
      '/22809915073/SingleCare_Drug-Page/Drug-page_top',
      getAllAdSizes(sizeMapping.top),
      'div-gpt-ad-1685465601155-0'
    )
    .defineSizeMapping(sizeMapping.top)
    .addService(googletag.pubads())
  // googletag
  //   .defineSlot(
  //     '/22809915073/SingleCare_Drug-Page/drug-page_in-content-1st',
  //     getAllAdSizes(inContentMapping),
  //     'div-gpt-ad-1685465718933-0'
  //   )
  //   .defineSizeMapping(inContentMapping)
  //   .addService(googletag.pubads())
  googletag
    .defineSlot(
      '/22809915073/SingleCare_Drug-Page/Drug-page_in-content-2nd',
      getAllAdSizes(sizeMapping.inContent),
      'div-gpt-ad-1685465793237-0'
    )
    .defineSizeMapping(sizeMapping.inContent)
    .addService(googletag.pubads())
  googletag
    .defineSlot(
      '/22809915073/SingleCare_Drug-Page/Drug-page_left-hand_1st',
      getAllAdSizes(sizeMapping.leftRight),
      'div-gpt-ad-1685465849075-0'
    )
    .defineSizeMapping(sizeMapping.leftRight)
    .addService(googletag.pubads())
  googletag
    .defineSlot(
      '/22809915073/SingleCare_Drug-Page/Drug-page_right-hand_1st',
      getAllAdSizes(sizeMapping.leftRight),
      'div-gpt-ad-1685465967121-0'
    )
    .defineSizeMapping(sizeMapping.leftRight)
    .addService(googletag.pubads())
  const bottomAnchorSlot = googletag
    .defineSlot(
      '/22809915073/SingleCare_Drug-Page/Drug-page_bottom-anchor',
      getAllAdSizes(sizeMapping.anchor),
      'div-gpt-ad-1685723492183-0'
    )
    .defineSizeMapping(sizeMapping.anchor)
    .addService(googletag.pubads())
    let stickyAnchorInitialized = false;
    googletag.pubads().addEventListener('slotOnload', event => {
      // we need to know when if the anchor ad is being served and loaded
      // if not, no need to create a sticky ad
      if (event.slot == bottomAnchorSlot) {
        // the anchor ad is currently loaded

        if (stickyAnchorInitialized === false) {
          // as the ads can be refreshed, this event will be fired on each refresh
          // so we need to make sure we only initialize the code for the sticky ad once
          const stickyContainer = document.querySelector('#bottomStickyAd');
          const topTriggerElement = document.querySelector('#drug-pricing');
          const bottomTriggerElement = document.querySelector('.homepage-footer');

          // we'll use intersection observer to track if the sticky ad can be shown
          const triggerObserver = new IntersectionObserver(
            entries => {
              let hideAd = false;
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  hideAd = true;
                }
              });

              if (hideAd == true) {
                // one of the trigger elements is visible, hide the ad
                stickyContainer.classList.remove('bottomAdsBanner');
              } else {
                // the trigger element is not visible, show the ad
                stickyContainer.classList.add('bottomAdsBanner');
              }
            },
            {
              threshold: 0
            }
          );
          triggerObserver.observe(topTriggerElement);
          triggerObserver.observe(bottomTriggerElement);
          stickyAnchorInitialized = true;
        }
      }
    });
  // targeting variables
  // left this unchanged
  var seo_nameMeta = document.querySelector("meta[property='seo_name']")
  if (seo_nameMeta) {
    googletag
      .pubads()
      .setTargeting('seo_name', seo_nameMeta.content.slice(0, 40))
  }

  var placement_nameMeta = document.querySelector(
    "meta[property='placement_name']"
  )
  if (placement_nameMeta) {
    googletag
      .pubads()
      .setTargeting(
        'placement_name',
        placement_nameMeta.content.slice(0, 40)
      )
  }

  var environmentMeta = document.querySelector(
    "meta[property='environment']"
  )
  if (environmentMeta) {
    googletag
      .pubads()
      .setTargeting('environment', environmentMeta.content.slice(0, 40))
  }

  var logged_inMeta = document.querySelector("meta[property='logged_in']")
  if (logged_inMeta) {
    googletag
      .pubads()
      .setTargeting('logged_in', logged_inMeta.content.slice(0, 40))
  }

  googletag.pubads().enableSingleRequest()
  googletag.pubads().collapseEmptyDivs()
  googletag.pubads().setCentering(true);
  googletag.pubads().disableInitialLoad()
  adSlotsBorder();
  window.scShowAds = false;
  googletag.enableServices()
})
`;
